<script setup lang="ts">
    interface StatisticsCard {
        label: string;
        value: string | number;
        boxColor: string;
        textColor: string;
    }

    const props = defineProps<{
        card: StatisticsCard;
        modifier?: string[];
    }>();

    const modifierClasses = computed(() => {
        if (!props.modifier || props.modifier.length === 0) {
            return '';
        }

        const modifierMap: Record<string, string> = {
            big: 'big py-[20px]',
        };

        return props.modifier
            .map((mod) => modifierMap[mod])
            .filter(Boolean)
            .join(' ');
    });

    const { $price } = useNuxtApp();
</script>

<template>
    <div
        class="rounded-lg px-4 py-[10px] text-center flex flex-col justify-center items-center md:max-w-[130px] max-md:w-[calc(50%-8px)]"
        :class="[card.boxColor, modifierClasses]"
    >
        <div
            class="label text-xs mb-1 leading-none"
            :class="card.textColor"
        >
            {{ $t(card.label) }}
        </div>
        <div
            class="value text-md font-extrabold leading-none"
            :class="card.textColor"
        >
            {{ typeof card.value === 'number' ? $price(card.value) : card.value }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .big {
        .label {
            @apply text-lg;
        }
        .value {
            @apply text-3xl;
        }
    }
</style>
